// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_3X6wH","checkmark":"index_checkmark_INtpQ"};